import React from 'react';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/i18n-react';
import './styles.scss';

const VerifiedReviews = () => (
    <div className={classNames('verified-reviews', 'box-shadow-z1')}>
        <i className="verification-icon" />
        <I18n k="reviews.verified.body" />
    </div>
);

export default VerifiedReviews;
